import cryptoJs from 'crypto-js';

// 随机生成指定数量的16进制key（该方法非必须，也可自己指定key）
const generatekey = postSource => {
  let key = '';
  // settlement 订单接口
  if (postSource === 'settlement') {
    key =
      process.env.NODE_ENV === 'production'
        ? 'lomcj07ab7r64yr1tnc76d63e0ebbbe5'
        : '8827507ab7r64yr1b6e98763e0ebbbe5';
    // newSettle 结算接口
  } else if (postSource === 'newSettle') {
    key =
      process.env.NODE_ENV === 'production'
        ? 'P9i8d7gli73673UJEE6D44ro'
        : 'P9i8d7gli73673UJDD6D44ro';
  } else if (postSource === 'service' || postSource === 'service-league') {
    key =
      process.env.NODE_ENV === 'production'
        ? 'lomcj07ab7r64yr1tnc76d63e0ebbbe5'
        : 'P9i8d7gli73673UJDD6D44ro';
  } else if (postSource === 'member' || postSource === 'member-buyer') {
    key =
      process.env.NODE_ENV === 'production'
        ? 'f306d61f01ce4e0294ef502de758fb26'
        : '8827507ab7r64yr1b6e98763e0ebbbe5';
  }
  return key;
};
/*
 * message:需要解密的字符串，
 * key： 密钥（加密解密密钥同一个）
 */
//DES加密
const encryptDesPost = (message, key = 'abcd@1234') => {
  var keyHex = cryptoJs.enc.Utf8.parse(key);
  var option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 };
  var encrypted = cryptoJs.DES.encrypt(message, keyHex, option);
  return encrypted.ciphertext.toString(cryptoJs.enc.Base64); // 返回hex格式密文，如需返回base64格式：encrypted.toString()
};

//DES解密
const decryptDes = (message, key = 'abcd@1234') => {
  var keyHex = cryptoJs.enc.Utf8.parse(key);
  var decrypted = cryptoJs.DES.decrypt(
    {
      // ciphertext: cryptoJs.enc.Hex.parse(message)
      ciphertext: cryptoJs.enc.Base64.parse(message)
    }, // 若 message 是 base64 格式，则无需转16进制hex，直接传入 message 即可
    keyHex,
    {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7
    }
  );
  return decrypted.toString(cryptoJs.enc.Utf8);
};

export { generatekey, encryptDesPost, decryptDes };



// WEBPACK FOOTER //
// ./src/utils/des-post.js